import React from 'react';
import { classnames } from '../../../../../utils/classnames';
import AttendeeDetailAnswer from '../../../misc/attendee-detail-item/attendeeDetailAnswer';
import AttendeeCard from '../../../cards/attendeeCard/attendeeCard';
import './attendeeInfos.css';

export default function AttendeeInfos({attendee = {}, showMore = [], setShowMore = () => {}, index = 0}) {

    const toggleShowMore = React.useCallback(() => {
        setShowMore(previousState => {
            let newState = [...previousState];
            newState[index] = !newState[index];
            return newState;
        })
    },[index]);

    return (
        <AttendeeCard showMore={showMore} index={index} attendee={attendee} formAttendee={attendee} toggleShowMore={toggleShowMore} disabled={!attendee.details.length}>
            <div className={classnames('neo-attendee-form', {'show-more': showMore[index]})}>
                <div className='neo-attendee-form-divider'/>
                <dl>
                    {attendee.details.length && attendee.details.map((answer, i) => <AttendeeDetailAnswer answer={answer} key={i}/>)}
                </dl>
            </div>
        </AttendeeCard>
    )
}
